<template>
  <b-container class="d-flex align-items-center justify-content-center my-5">
    <div id="login-main" class="spnod-admin__form--main d-flex align-items-center flex-column">
      <h5 class="h5 mb-4">Please Complete Your Nutrition Assessment</h5>
      <SurveyForm :user="user" :signup="true"/>
    </div>
  </b-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import SurveyForm from '../../components/Surveys/SurveyForm'

export default {
  name: 'Survey',
  components: { SurveyForm },
  data() {
    return {
      user: {}
    }
  },
  computed: {
    ...mapGetters(['getMyInfo'])
  },
  methods: {
    ...mapActions(['getMe'])
  },
  mounted: async function() {
    await this.getMe()
    this.user = this.getMyInfo
  }
}
</script>



// WEBPACK FOOTER //
// src/app/Pages/AdminAuth/Survey.vue?3de8dc18